module.exports = __webpack_public_path__ + "static/media/ekar.74bb5be3.ogg";